import React, { useRef } from 'react';

/**
 * Magnetic wrapper: children attract slightly to cursor within bounds.
 * Usage: <MagneticButton><button>...</button></MagneticButton>
 */
const MagneticButton = ({ children, strength = 0.35, className = '' }) => {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    const dx = (e.clientX - cx) * strength;
    const dy = (e.clientY - cy) * strength;
    el.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
  };
  const onLeave = () => {
    const el = ref.current;
    if (el) el.style.transform = 'translate3d(0,0,0)';
  };

  return (
    <div onMouseMove={onMove} onMouseLeave={onLeave} className={`inline-block ${className}`}>
      <div ref={ref} className="magnetic inline-block">
        {children}
      </div>
    </div>
  );
};

export default MagneticButton;
